var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWgWellGuardianLogoHalf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 30,
    viewBox: "0 0 132 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7696 10.8071L13.9853 0L3.20098 10.8071V2.96484H7.98039L10.4314 0.508686H0.75V16.7368L13.9853 3.47353L27.2206 16.7368V0.508686H17.5392L19.9902 2.96484H24.7696V10.8071ZM18.2021 11.1028L13.9854 6.87715L2.44835 18.4385L13.9854 29.9999L25.5224 18.4385L19.3448 12.2479L12.2523 19.3555L13.9854 21.0923L19.3448 15.7215L22.0562 18.4385L13.9854 26.5264L5.91456 18.4385L13.9854 10.3507L16.469 12.8396L18.2021 11.1028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgWellGuardianLogoHalf);
export default __webpack_public_path__ + "static/media/wg-well-guardian-logo-half.8199a29e4db8a1d26cf5cddaba4cfbf7.svg";
export { ForwardRef as ReactComponent };